import { OrderSummary } from '@/types';
import { FormattedOrderSummaryData } from './types';

const findOrderRowIndex = (
  rows: FormattedOrderSummaryData[],
  item: OrderSummary,
) =>
  rows.findIndex(
    (row) =>
      row.customerName === item.customerName &&
      row.consigneeCode === item.consigneeCode &&
      row.country === item.country,
  );

export const formatOrderSummary = (orderSummaryEntities: OrderSummary[]) =>
  orderSummaryEntities.reduce((result, item) => {
    const orderRowIndex = findOrderRowIndex(result, item);

    const { companyId, consigneeCode, customerName, country } = item;
    if (orderRowIndex === -1) {
      return [
        ...result,
        {
          companyId,
          consigneeCode,
          customerName,
          country,
          items: [item],
        },
      ] as FormattedOrderSummaryData[];
    }
    const updatedResult = [...result];
    updatedResult[orderRowIndex].items.push(item);

    return updatedResult;
  }, [] as FormattedOrderSummaryData[]);
